//const API_BASE_URL = "http://localhost/platform.socialjet.ai";
 const API_BASE_URL = "https://platform.socialjet.ai/app";


export const API = {
  baseUrl: API_BASE_URL,

  account: `${API_BASE_URL}/account`,
  assistant: `${API_BASE_URL}/assistant`,
  blueprints: `${API_BASE_URL}/blueprints`,
  canva: `${API_BASE_URL}/canva`,
  captions: `${API_BASE_URL}/captions`,
  categories: `${API_BASE_URL}/categories`,
  courses: `${API_BASE_URL}/courses`,
  drafts: `${API_BASE_URL}/drafts`,
  emails: `${API_BASE_URL}/emails`,
  events: `${API_BASE_URL}/events`,
  forYou: `${API_BASE_URL}/for-you`,
  images: `${API_BASE_URL}/images`,
  meta: `${API_BASE_URL}/meta`,
  myCalendar: `${API_BASE_URL}/my-calendar`,
  myDrafts: `${API_BASE_URL}/my-drafts`,
  reels: `${API_BASE_URL}/reels`,
  socialMedia: `${API_BASE_URL}/social-media`,
  stripe: `${API_BASE_URL}/stripe`,
  templates: `${API_BASE_URL}/templates`,
  videos: `${API_BASE_URL}/videos`,
    paypal: `${API_BASE_URL}/paypal`
};

export default API;